module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gd-Ha-Ib-Jb.9dd9feff.png";